const transformCelsiusToFahrenheit = (value?: number, decimals: number = 0): number => {
    if (value === null || value === undefined) return 0
    return parseFloat((value * (9 / 5) + 32).toFixed(decimals))
}

const transformFahrenheitToCelsius = (value?: number, decimals: number = 0): number => {
    if (value === null || value === undefined) return 0
    return parseFloat(((value - 32) * (5 / 9)).toFixed(decimals))
}

const celsiusToFahrenheit = (celsius: number): number => {
    return Number(((celsius * 9) / 5 + 32).toFixed(2))
}
const parseTemperature = (
    temperature: number,
    {
        temperatureUnit = 'celsius',
        decimals = 1,
        minimumDecimals = 0,
        includeUnit = true,
        locale = 'en-US'
    }: {
        temperatureUnit?: 'celsius' | 'fahrenheit'
        decimals?: number
        minimumDecimals?: number
        includeUnit?: boolean
        locale?: string
    } = {}
) => {
    if (temperature === null || temperature === undefined || isNaN(temperature)) {
        return temperature
    }

    const degrees = temperatureUnit === 'fahrenheit' ? '°F' : '°C'
    const value = temperatureUnit === 'fahrenheit' ? celsiusToFahrenheit(temperature) : temperature

    const formattedValue = value.toLocaleString(locale, {
        minimumFractionDigits: minimumDecimals,
        maximumFractionDigits: decimals
    })

    const returnNumber: number = parseFloat(formattedValue)
    const returnString: string = `${formattedValue}${includeUnit ? degrees : ''}`
    return includeUnit ? returnString : returnNumber
}

export { transformCelsiusToFahrenheit, transformFahrenheitToCelsius, parseTemperature }
